module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/none_panel_pic-201d6ac155e96f64611e8875ec0dd81e.png";